import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from '../../axios/axiosconf';
import { formatDateOnly } from '../superadmin/superadminDateUtils';

function VistaPreviaEgreso() {
    const { id } = useParams();
    const [egreso, setEgreso] = useState(null);
    const [client, setClient] = useState(null);
    const [proveedor, setProveedor] = useState(null);
    const [encabezadoPersonalizado, setEncabezadoPersonalizado] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        cargarDatos();
    }, [id]);

    const getMetodoPagoTexto = (codigo) => {
        const metodosPago = {
            '10': 'Efectivo',
            '42': 'Consignación bancaria',
            '1': 'Instrumento no definido',
            '20': 'Cheque',
            '30': 'Transferencia Crédito',
            '31': 'Transferencia Débito',
            '45': 'Transferencia Crédito Bancario',
            '47': 'Transferencia Débito Bancaria',
            '48': 'Tarjeta Crédito',
            '49': 'Tarjeta Débito',
            'ZZZ': 'Acuerdo mutuo'
        };
        return metodosPago[codigo] || codigo;
    };

    const cargarDatos = async () => {
        let userdata = JSON.parse(localStorage.getItem('userdata') || '{}');

        try {
            const [clienteResponse, egresoResponse] = await Promise.all([
                axios.get(`/get-client?uid=${userdata.user_id}`),
                axios.get(`/egreso/${id}?uid=${userdata.user_id}`)
            ]);

            setClient(clienteResponse.data);
            setEgreso(egresoResponse.data);

            // Extraer datos del proveedor del egreso
            setProveedor({
                nombre_proveedor: egresoResponse.data.nombre_proveedor,
                numero_documento: egresoResponse.data.proveedor_documento,
                tipo_documento: egresoResponse.data.proveedor_tipo_documento
            });

            // Cargar encabezado personalizado según el users_id del egreso
            if (egresoResponse.data.users_id) {
                try {
                    const encabezadoResponse = await axios.get(`/encabezado-personalizado?uid=${egresoResponse.data.users_id}`);
                    if (encabezadoResponse.status === 200 && encabezadoResponse.data && encabezadoResponse.data.estado === 1) {
                        setEncabezadoPersonalizado(encabezadoResponse.data);
                        console.log('Encabezado personalizado cargado:', encabezadoResponse.data);
                    }
                } catch (error) {
                    console.log('No hay encabezado personalizado para este usuario');
                }
            }

        } catch (error) {
            console.error('Error al cargar datos:', error);
            alert('Error al cargar los datos del egreso');
        } finally {
            setLoading(false);
        }
    };

    const imprimir = () => {
        window.print();
    };

    const descargarPDF = async () => {
        try {
            // Generar PDF
            const html2pdf = await import('html2pdf-fix-jspdf');
            const element = document.querySelector('.invoice');
            
            const opt = {
                margin: 10,
                filename: `egreso-${egreso.numero}.pdf`,
                image: { type: 'jpeg', quality: 0.95 },
                html2canvas: {
                    scale: 2,
                    useCORS: true,
                    logging: false,
                    letterRendering: true
                },
                jsPDF: {
                    unit: 'mm',
                    format: 'letter',
                    orientation: 'portrait',
                    compress: true
                },
                pagebreak: {
                    mode: ['avoid-all', 'css', 'legacy']
                }
            };
            
            // Generar y guardar el PDF directamente
            await html2pdf.default().from(element).set(opt).save();
            
        } catch (error) {
            console.error('Error generando PDF:', error);
            alert('Error al generar el PDF. Por favor, intente nuevamente.');
        }
    };

    const getNombreUsuario = () => {
        // Obtener nombre del usuario directamente del objeto egreso
        if (egreso.usuario_nombre && egreso.usuario_apellido) {
            return `${egreso.usuario_nombre} ${egreso.usuario_apellido}`;
        }
        return 'N/A';
    };

    const generarEncabezadoHTML = () => {
        if (!encabezadoPersonalizado) {
            return null;
        }

        return (
            <div style={{ marginBottom: '10px' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', backgroundColor: '#ffffff' }}>
                    <tbody>
                        <tr>
                            <td style={{ width: '30%', padding: '2px', fontSize: '10px', lineHeight: '1.1', verticalAlign: 'top', wordWrap: 'break-word' }}
                                dangerouslySetInnerHTML={{ __html: encabezadoPersonalizado.izquierda }} />
                            <td style={{ width: '40%', padding: '2px', textAlign: 'center', fontSize: '11px', lineHeight: '1.1', verticalAlign: 'top', wordWrap: 'break-word' }}
                                dangerouslySetInnerHTML={{ __html: encabezadoPersonalizado.centro }} />
                            <td style={{ width: '30%', padding: '2px', textAlign: 'right', fontSize: '10px', lineHeight: '1.1', verticalAlign: 'top', wordWrap: 'break-word' }}
                                dangerouslySetInnerHTML={{ __html: encabezadoPersonalizado.derecha }} />
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    };

    if (loading || !egreso || !client || !proveedor) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <div className="text-center">
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Cargando...</span>
                    </div>
                    <p className="mt-2">Cargando egreso...</p>
                </div>
            </div>
        );
    }

    const nombreUsuario = getNombreUsuario();

    const formatearFecha = (fecha) => formatDateOnly(fecha);

    const obtenerDocumentoProveedor = () => {
        if (proveedor.numero_documento) {
            return proveedor.numero_documento;
        }
        return '';
    };

    const getEstadoTexto = (estado) => {
        switch (estado) {
            case 0: return 'Generada';
            case 1: return 'Anulada';
            default: return 'Desconocido';
        }
    };

    return (
        <div className="container-fluid p-0">
            <div className="invoice p-2" id="invoice-content">
                {/* 🆕 Encabezado Personalizado */}
                {generarEncabezadoHTML()}

                {/* 🆕 BANNER: EGRESO */}
                <div className="row m-0 mb-2">
                    <div className="col-12 p-0">
                        <div style={{
                            backgroundColor: '#e9ecef',
                            padding: '4px 8px',
                            fontWeight: 'bold',
                            fontSize: '10px',
                            borderRadius: '3px',
                            textAlign: 'center',
                            border: '1px solid #dee2e6'
                        }}>
                            EGRESO N° {egreso.numero}
                        </div>
                    </div>
                </div>

                {/* 🆕 Datos del Egreso */}
                <div className="row m-0 mb-2">
                    <div className="col-12 p-0">
                        <table className="table table-bordered w-100 mb-0" style={{ fontSize: '10px' }}>
                            <tbody>
                                <tr>
                                    <td className="bg-light font-weight-bold align-middle p-1" style={{ width: '15%' }}>FECHA CREACIÓN</td>
                                    <td className="bg-white p-1" style={{ width: '18%' }}>{formatearFecha(egreso.fecha_creacion)}</td>
                                    <td className="bg-light font-weight-bold align-middle p-1" style={{ width: '15%' }}>FORMA DE PAGO</td>
                                    <td className="bg-white p-1" style={{ width: '18%' }}>{getMetodoPagoTexto(egreso.forma_pago)}</td>
                                    <td className="bg-light font-weight-bold align-middle p-1" style={{ width: '15%' }}>ESTADO</td>
                                    <td className="bg-white p-1" style={{ width: '19%' }}>
                                        <span style={{ color: egreso.estado === 0 ? '#28a745' : '#dc3545', fontWeight: 'bold' }}>
                                            {getEstadoTexto(egreso.estado)}
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="bg-light font-weight-bold align-middle p-1">CREADO POR</td>
                                    <td colSpan="5" className="bg-white p-1">{nombreUsuario}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Datos del Proveedor */}
                <div className="row m-0 mb-2">
                    <div className="col-12 p-0">
                        <table className="table table-bordered w-100 mb-0" style={{ fontSize: '10px' }}>
                            <tbody>
                                <tr>
                                    <td className="bg-light font-weight-bold align-middle p-1" style={{ width: '15%' }}>PROVEEDOR</td>
                                    <td className="bg-white p-1" style={{ width: '35%' }}>{proveedor.nombre_proveedor}</td>
                                    <td className="bg-light font-weight-bold align-middle p-1" style={{ width: '15%' }}>DOCUMENTO</td>
                                    <td className="bg-white p-1" style={{ width: '35%' }}>{obtenerDocumentoProveedor()}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Tabla de Conceptos */}
                <div className="row m-0">
                    <div className="col-12 p-0 table-responsive">
                        <table className="table table-striped w-100 mb-0" style={{ fontSize: '10px' }}>
                            <thead>
                                <tr>
                                    <th className="p-1">Código</th>
                                    <th className="p-1">Descripción</th>
                                    <th className="p-1">Cantidad</th>
                                    <th className="p-1">Precio Unit.</th>
                                    <th className="p-1">Descuento</th>
                                    <th className="p-1">IVA</th>
                                    <th className="text-right p-1">Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {egreso.detalle?.map((item, index) => {
                                    const lineTotal = item.vrunitario * item.cantidad;
                                    const descuento = lineTotal * (item.descuento / 100);
                                    const baseImponible = lineTotal - descuento;
                                    const iva = baseImponible * (item.iva / 100);
                                    const total = baseImponible + iva;

                                    return (
                                        <tr key={index}>
                                            <td className="p-1">{item.concepto_pago?.codigo}</td>
                                            <td className="p-1">{item.concepto_pago?.nombre}</td>
                                            <td className="p-1">{item.cantidad}</td>
                                            <td className="p-1">${Math.round(parseFloat(item.vrunitario)).toLocaleString('es-CO')}</td>
                                            <td className="p-1">{item.descuento}%</td>
                                            <td className="p-1">{item.iva}%</td>
                                            <td className="text-right p-1">${Math.round(total).toLocaleString('es-CO')}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colSpan="5" style={{ border: 'none' }}></td>
                                    <td className="text-left font-weight-bold pl-2 p-1" style={{ borderTop: '2px solid #dee2e6' }}>Subtotal:</td>
                                    <td className="text-right p-1" style={{ borderTop: '2px solid #dee2e6' }}>${Math.round(parseFloat(egreso.valor_bruto)).toLocaleString('es-CO')}</td>
                                </tr>
                                <tr>
                                    <td colSpan="5" style={{ border: 'none' }}></td>
                                    <td className="text-left font-weight-bold pl-2 p-1" style={{ borderTop: '1px solid #dee2e6', fontSize: '10px' }}>Total:</td>
                                    <td className="text-right font-weight-bold p-1" style={{ borderTop: '1px solid #dee2e6', fontSize: '10px' }}>${Math.round(parseFloat(egreso.valor_total)).toLocaleString('es-CO')}</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>

                {/* Observaciones */}
                {egreso.observaciones && (
                    <div className="row m-0 mt-2">
                        <div className="col-12 p-0">
                            <h6 style={{ fontSize: '10px', marginBottom: '2px', fontWeight: 'bold' }}>Observaciones:</h6>
                            <p style={{ fontSize: '10px', marginBottom: '0' }}>{egreso.observaciones}</p>
                        </div>
                    </div>
                )}
            </div>

            <style>{`
                /* Estilos base para pantalla e impresión */
                .invoice {
                    font-family: Arial, sans-serif;
                    font-size: 10px;
                }
                
                .invoice table {
                    border-collapse: collapse;
                    width: 100%;
                }
                
                .invoice .table-bordered {
                    border: 1px solid #dee2e6;
                }
                
                .invoice .table-bordered td,
                .invoice .table-bordered th {
                    border: 1px solid #dee2e6;
                    padding: 4px;
                }
                
                .invoice .bg-light {
                    background-color: #f8f9fa !important;
                }
                
                .invoice .bg-white {
                    background-color: #ffffff !important;
                }
                
                .invoice .font-weight-bold {
                    font-weight: bold;
                }
                
                .invoice .text-left {
                    text-align: left;
                }
                
                .invoice .text-right {
                    text-align: right;
                }
                
                .invoice .text-center {
                    text-align: center;
                }
                
                .invoice .p-1 {
                    padding: 4px;
                }
                
                .invoice .pl-2 {
                    padding-left: 8px;
                }
                
                .invoice .table-striped tbody tr:nth-of-type(odd) {
                    background-color: #f8f9fa;
                }
                
                .invoice .table-striped tbody tr:nth-of-type(even) {
                    background-color: #ffffff;
                }
                
                @media print {
                    .no-print { 
                        display: none !important; 
                    }
                    
                    body, html, #root {
                        height: auto;
                        margin: 0;
                        padding: 0;
                        background-color: white;
                    }
                    
                    .container-fluid {
                        padding: 0 !important;
                        margin: 0 !important;
                    }
                    
                    .invoice {
                        width: 100% !important;
                        padding: 0 !important;
                        margin: 0 !important;
                        font-family: Arial, sans-serif !important;
                        font-size: 10px !important;
                    }
                    
                    .invoice .row {
                        page-break-inside: avoid;
                        margin: 0 !important;
                        display: block !important;
                        width: 100% !important;
                    }
                    
                    .invoice .col-12 {
                        width: 100% !important;
                        padding: 0 !important;
                        display: block !important;
                    }
                    
                    .invoice table {
                        page-break-inside: auto;
                        width: 100% !important;
                        border-collapse: collapse !important;
                    }
                    
                    .invoice tr {
                        page-break-inside: avoid;
                        page-break-after: auto;
                    }
                    
                    .invoice td, 
                    .invoice th {
                        padding: 2px !important;
                        border: 1px solid #dee2e6 !important;
                    }
                    
                    .invoice .bg-light {
                        background-color: #f8f9fa !important;
                        -webkit-print-color-adjust: exact;
                        print-color-adjust: exact;
                    }
                    
                    .invoice .bg-white {
                        background-color: #ffffff !important;
                        -webkit-print-color-adjust: exact;
                        print-color-adjust: exact;
                    }
                    
                    .invoice .table-striped tbody tr:nth-of-type(odd) {
                        background-color: #f8f9fa !important;
                        -webkit-print-color-adjust: exact;
                        print-color-adjust: exact;
                    }
                    
                    .invoice .table-striped tbody tr:nth-of-type(even) {
                        background-color: #ffffff !important;
                        -webkit-print-color-adjust: exact;
                        print-color-adjust: exact;
                    }
                    
                    @page {
                        size: landscape;
                        margin: 5mm; 
                    }
                }
            `}</style>
        </div>
    );
}

export default VistaPreviaEgreso;
